import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const Footer = () => {
  const footerLinks = {
    product: [
      { id: 'footer_features', label: 'Features', href: '/dashboard' },
      { id: 'footer_pricing', label: 'Why Free', href: '/pricing' },
      { id: 'footer_how_it_works', label: 'How It Works', href: '/dashboard' },
      { id: 'footer_examples', label: 'Examples', href: '/dashboard' },
    ],
    company: [
      { id: 'footer_our_story', label: 'Our Story', href: '/ourstory' },
      { id: 'footer_contact', label: 'Contact', href: '/faq' },
      { id: 'footer_faqs', label: 'FAQs', href: '/faq' },
      { id: 'footer_blog', label: 'Blog', href: '/homepage' },
    ],
    legal: [
      { id: 'footer_privacy', label: 'Privacy', href: '/pipa-compliance' },
      { id: 'footer_terms', label: 'Terms', href: '/pipa-compliance' },
      { id: 'footer_pipa', label: 'PIPA Compliance', href: '/pipa-compliance' },
      { id: 'footer_security', label: 'Security', href: '/pipa-compliance' },
    ],
  };

  return (
    <footer className="bg-white border-t border-border">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link href="/homepage" className="flex items-center gap-3 mb-6 group">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                <AppImage
                  src="/images/LF_logo-1771537865069.png"
                  alt="Legacy logo - candle with flame"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <span className="font-jakarta font-bold text-xl tracking-tight text-foreground">
                Legacy.bm
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              Preserve your legacy. Create meaningful messages that last forever.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-jakarta font-semibold text-sm text-foreground mb-4 uppercase tracking-wider">
              Product
            </h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-jakarta font-semibold text-sm text-foreground mb-4 uppercase tracking-wider">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-jakarta font-semibold text-sm text-foreground mb-4 uppercase tracking-wider">
              Legal
            </h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2026 Legacy.bm. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <Link href="/pipa-compliance" className="hover:text-primary transition-colors">
              Privacy
            </Link>
            <span>·</span>
            <Link href="/pipa-compliance" className="hover:text-primary transition-colors">
              Terms
            </Link>
            <span>·</span>
            <Link href="/pipa-compliance" className="hover:text-primary transition-colors">
              Security
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;